// extracted by mini-css-extract-plugin
module.exports = {"background-color":"#f6f4d2","otherEventColor":"#c96928","minieventColor":"#ed9b21","qnaColor":"#e6988e","workshopColor":"#78ac42","megaphoneColor":"#9a242b"};